import React from 'react'

import Inventory_Panel from './Inventory_panel'

const Inventory = () => {
  return (
  <>
 
  
  <Inventory_Panel/>


  </>
  )
}

export default Inventory